import clsx from 'clsx';
import * as React from 'react';
import { observer } from 'mobx-react';
import { sortingOptions } from '../Types';
import { Listbox, Transition } from '@headlessui/react';

interface Props {
  open: boolean;
}

const Dropdown: React.FC<Props> = ({ open }) => (
  <Transition
    show={open}
    as={React.Fragment}
    leave="transition ease-in duration-100"
    leaveFrom="opacity-100"
    leaveTo="opacity-0"
  >
    <Listbox.Options
      className={clsx(
        'absolute z-10 mt-1 max-h-60 w-full overflow-auto',
        'rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5',
        'focus:outline-none sm:text-sm',
      )}
    >
      {sortingOptions.map((sortingOption) => (
        <Listbox.Option
          key={sortingOption.value}
          className={({ active }) =>
            clsx(
              active ? 'bg-teal-600 text-white' : 'text-gray-900',
              'relative cursor-default select-none py-2 pl-3 pr-9 text-sm',
            )
          }
          value={sortingOption}
        >
          {() => (
            <>
              <span>{sortingOption.label}</span>
            </>
          )}
        </Listbox.Option>
      ))}
    </Listbox.Options>
  </Transition>
);

export default observer(Dropdown);
